var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatPurple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#8F21E6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8F21E6",
  d: "M16.082 13.61H47.01v30.927H16.082z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M31.546 17.476c-6.405 0-11.598 5.192-11.598 11.598v11.598h11.598c6.406 0 11.598-5.193 11.598-11.598s-5.192-11.598-11.598-11.598M17.371 29.074c0-7.83 6.347-14.176 14.175-14.176 7.83 0 14.176 6.347 14.176 14.176s-6.347 14.175-14.176 14.175H18.66a1.29 1.29 0 0 1-1.289-1.289z"
})));
export default SvgChatPurple;